module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Medium-f4a5ba47585b01d8ad786fb0e7eead6b.otf";